<template>
  <app-logged>
    <v-flex xs12>
      <validation-observer
        ref="observer"
        v-slot="{ invalid }"
        tag="form"
      >
        <v-form>
          <app-widget
            :actions="!visita.balancete_nao_requerido"
            class-widget="md6 offset-md3 sm8 offset-sm2 xs12"
          >
            <div slot="widget-content">
              <AppFormHeader
                title="Visita selecionada"
                icon="description"
              />
              <AppVisitaTable />
              <v-alert
                class="mt-4"
                v-if="visita.balancete_nao_requerido"
                border="left"
                colored-border
                type="warning"
                elevation="2"
              >
                Visita dispensada do envio de balancete
              </v-alert>
              <div
                class="mt-4"
                v-else
              >
                <AppFormHeader
                  title="Carregar tabela do excel"
                  icon="table_view"
                />
                <validation-provider
                  name="arquivo excel"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-file-input
                    accept=".xlsx"
                    label="Selecione um arquivo"
                    outlined
                    v-model="file"
                    :hint="(file) ? file.name : ''"
                  />
                </validation-provider>
              </div>
            </div>
            <div slot="widget-actions">
              <v-spacer />
              <app-button
                @click.native.prevent="carregar"
                :disable="invalid"
              >
                Importar
              </app-button>
            </div>
          </app-widget>
        </v-form>
      </validation-observer>
    </v-flex>
  </app-logged>
</template>
<script>
import AppLogged from '@/components/layouts/AppLogged'
import { mapGetters, mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import AppWidget from '@/components/AppWidget'
import AppButton from '@/components/AppButton'
import AppFormHeader from '@/components/AppFormHeader'
import AppVisitaTable from '@/components/AppVisitaTable'
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    AppLogged,
    AppWidget,
    AppButton,
    AppVisitaTable,
    AppFormHeader
  },
  data () {
    return {
      file: null
    }
  },
  computed: {
    ...mapGetters(['visita'])
  },
  watch: {
    file (val) {
      console.log(val)
    }
  },
  methods: {
    ...mapActions(['carregarBalancete']),
    async carregar () {
      await this.carregarBalancete({
        file: this.file,
        visita: this.visita.id
      })
    }
  }
}
</script>
